var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNurses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_2183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57144 14.5723H15.4286",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.1426V17.9997",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 6H2.57143C2.11678 6 1.68074 6.18061 1.35925 6.5021C1.03776 6.82359 0.857147 7.25963 0.857147 7.71429V21.4286C0.857147 21.8832 1.03776 22.3193 1.35925 22.6408C1.68074 22.9622 2.11678 23.1429 2.57143 23.1429H21.4286C21.8832 23.1429 22.3193 22.9622 22.6408 22.6408C22.9622 22.3193 23.1429 21.8832 23.1429 21.4286V7.71429C23.1429 7.25963 22.9622 6.82359 22.6408 6.5021C22.3193 6.18061 21.8832 6 21.4286 6Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 6.00028V2.57171C17.1429 2.11705 16.9622 1.68102 16.6408 1.35952C16.3193 1.03803 15.8832 0.857422 15.4286 0.857422H8.57143C8.11678 0.857422 7.68074 1.03803 7.35925 1.35952C7.03776 1.68102 6.85715 2.11705 6.85715 2.57171V6.00028",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_2183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurses);
export default __webpack_public_path__ + "static/media/nurses.a92e46b2b0a1f66a6f3a39e128781937.svg";
export { ForwardRef as ReactComponent };